import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ManagePackageLeadsComponent } from './manage-package-leads/manage-package-leads.component';


const routes: Routes = [
  {
    path : "",
    component : ManagePackageLeadsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagePackageLeadsRoutingModule { }
